export default __webpack_public_path__ + "img/ocpOesmv.e5f36f6c.svg";